<template>
  <qtm-text-field ref="input" v-model="model" v-bind="$attrs" @update:model-value="clean" />
</template>

<script setup lang="ts">

const model = defineModel<any>()

const clean = (value: string | null) => {
  const cleanValue = value?.replace(/[^0-9.-]/g, '') ?? ''

  model.value = cleanValue
}

const input = ref<any>(null)
const focus = () => {
  input.value?.focus()
}

onMounted(() => {
  if (model.value) {
    model.value = Number(model.value)
  }
})

defineExpose({ focus })
</script>
